import { convertToIndianTimeZone } from "../utils/utils";

export default function ConversationItem({ id, isSelected, startedAt, endedAt }) {
  const truncatedId = id.length > 27 ? `${id.substring(0, 17)}...` : id;
  
  return (
    <div
      style={{
        backgroundColor: isSelected ? '#edf5ff' : '#f5f7fa',
        borderRadius: '12px',
        padding: '14px 20px',
        margin: '10px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box',
        cursor: 'pointer',
        boxShadow: isSelected 
          ? '0 2px 6px rgba(0, 80, 255, 0.12)' 
          : '0 1px 3px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease',
        border: isSelected ? '1px solid rgba(0, 120, 255, 0.2)' : '1px solid rgba(0, 0, 0, 0.05)',
      }}
    >
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <div
          style={{
            fontSize: '15px',
            fontWeight: '600',
            color: isSelected ? '#0066cc' : '#333',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span style={{ marginRight: '8px' }}>
            <i className="ri-message-3-line" style={{ fontSize: '16px', opacity: 0.8 }}></i>
          </span>
          {truncatedId}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span
            style={{
              fontSize: '13px',
              color: '#666',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <i className="ri-time-line" style={{ marginRight: '5px', fontSize: '12px', opacity: 0.7 }}></i>
            Started: {convertToIndianTimeZone(startedAt)}
          </span>
          <span
            style={{
              fontSize: '13px',
              color: '#666',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <i className="ri-check-double-line" style={{ marginRight: '5px', fontSize: '12px', opacity: 0.7 }}></i>
            Ended: {convertToIndianTimeZone(endedAt)}
          </span>
        </div>
      </div>
      <div 
        style={{ 
          opacity: 0.7,
          transition: 'opacity 0.2s ease',
          marginLeft: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <i className="ri-arrow-right-s-line" style={{ fontSize: '20px', color: '#666' }}></i>
      </div>
    </div>
  );
}